import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=12513292&scoped=true&"
import script from "./category.js?vue&type=script&lang=js&"
export * from "./category.js?vue&type=script&lang=js&"
import style0 from "./category.scss?vue&type=style&index=0&id=12513292&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12513292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12513292')) {
      api.createRecord('12513292', component.options)
    } else {
      api.reload('12513292', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=12513292&scoped=true&", function () {
      api.rerender('12513292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/Category/Category.vue"
export default component.exports